let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2WgyB")).then(() => parcelRequire('4gQw3'));